export default "__VITE_ASSET__Bd86Z3Q2__"